import { PropsWithChildren, useState } from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { Toaster } from "../Base/Toaster";
import { useHeaderContext } from "@/hooks/useHeaderContext";

export const BasePage = ({ children }: PropsWithChildren) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { headerContent } = useHeaderContext();

  return (
    <div className="flex h-screen flex-col overflow-hidden overscroll-none print:block print:h-auto print:bg-white">
      <div className="print:hidden">
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)}>
          {headerContent}
        </Header>
      </div>

      <div className="relative flex flex-grow overflow-hidden bg-background print:block print:overflow-visible print:bg-white">
        {/* Main Content and Drawer */}
        <main className="flex flex-1 flex-grow flex-col overflow-x-auto overflow-y-auto bg-slate-900 text-slate-100 print:block print:h-auto print:overflow-visible print:bg-white print:text-black">
          {children}
        </main>
        <div className="print:hidden">
          <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
          <Toaster />
        </div>
      </div>

      <div className="print:hidden">
        <Footer />
      </div>
    </div>
  );
};
